<script context="module">

        export function rgbToString(r,g,b) {
                let colorString = "rgba("+r+","+g+","+b+")";
                return colorString;
        }

        export function rgbaToString(r,g,b,a){
                let colorString = "rgba("+r+","+g+","+b+","+a+")";
                return colorString;
        }
        
</script>